import { memo } from "react";
import isHtml from "/src/utils/isHtml";
import './Row.css';
import { isEqual } from "lodash";
import objectResolve from "/src/utils/objectResolve";
import * as purify from 'dompurify';

function Row({ info, cells, actions, functions, width }) {
    var widthPerCell = width / (cells.length + (actions.length > 0 ? 1 : 0));
    widthPerCell = isNaN(widthPerCell) ? 0 : widthPerCell;
    const row = cells.map((cell, index) => {

        let value = {};
        if (Array.isArray(cell.name)) {
            value = cell.name.map((c) => objectResolve(c, info))
        }

        else if (cell.name) {
            value = objectResolve(cell.name, info)
        }

        value = cell.show == undefined ? value : cell.show(value, { info, functions });
        return (
            isHtml(value) ? <td key={"td" + index} dangerouslySetInnerHTML={{ __html: purify.sanitize(value, { sanitize: true }) }} style={{ width : widthPerCell}}/> : <td key={"td" + index} style={{ width : widthPerCell}}>{value}</td>
        )
    });


    var actionComponent = actions.map((action, index) => {
    
        if (action.label != null || (action.condition != null && 
            (
                (Array.isArray(action.condition_match) && action.condition_match.includes(info[action.condition])) ||
                (!Array.isArray(action.condition_match) && info[action.condition] == action.condition_match)
            ))
        ) {

            return;
        }

        if (action.label != null || (action.other_condition != null && (info[action.other_condition] == action.other_match))) {
            return;
        }
        const { onClick } = { ...action };
        const click = onClick.bind(null, { row: { ...info }, ...functions })
        
        // delete action.condition_match;
        // delete action.condition;

        return <i key={index} {...action} onClick={click} aria-hidden="true" />
    })

    if (actions.length > 0) {
        row.push(<td key="td-action" className="actions" style={{ width: widthPerCell }}>{actionComponent}</td>)
    }

    return <tr>{row}</tr>;
};

export default Row;